import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'HomePage', component: () => import('@/pages/HomePageComponent.vue') },
    { path: '/tutorials', name: 'TutorialsPage', component: () => import('@/pages/TutorialsPageComponent.vue') },
    { path: '/tutorial/:id', name: 'TutorialDetailPage', component: () => import('@/pages/TutorialDetailPage.vue') },
    { path: '/resources', name: 'ResourcesPage', component: () => import('@/pages/ResourcesPageComponent.vue') },
    { path: '/articles', name: 'ArticlesPage', component: () => import('@/pages/ArticlesPageComponent.vue') },
    { path: '/article/:guid', name: 'ArticleDetailPage', component: () => import('@/pages/ArticleDetailPage.vue') },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: () => import('@/pages/AdminLoginPage.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/admin/upload',
      name: 'AdminUpload',
      component: () => import('@/pages/AdminUploadPage.vue'),
      meta: { requiresAuth: true }
    },
    // 未找到的路由重定向回首页
    { path: '*', redirect: { name: 'HomePage' } }
  ]
});

// 管理端路由守卫：只有持有 token 的用户可访问后台页面
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  
  // 如果已登录用户访问登录页，重定向到上传页
  if (to.name === 'AdminLogin' && token) {
    return next({ name: 'AdminUpload' });
  }
  
  // 如果路由不需要认证，直接放行
  if (!to.meta.requiresAuth) return next();

  // 需要认证的路由，检查 token
  if (token) {
    next();
  } else {
    next({ name: 'AdminLogin', query: { redirect: to.fullPath } });
  }
});

export default router;
